import React from 'react';
import { AddScanForm } from './forms';
import BaseLayout from '@/shared/components/layout/BaseLayout';

export const AddScanPage: React.FC = () => {
  return (
    <BaseLayout>
      <div className="container mx-auto max-w-4xl py-8 px-4">
        <AddScanForm />
      </div>
    </BaseLayout>
  );
};

